export default {
  title: 'Coordonnées bancaires',
  sections: {
    personal_info: 'Informations personnelles',
    address: 'Adresse',
  },
  labels: {
    account_number: 'Numéro de compte',
    routing_number: 'Numéro de routage',
    email: 'E-mail',
    full_name: 'Nom complet',
    street: 'Adresse',
    zip_code: 'Code postal',
    city: 'Ville',
  },
  tooltip: '{{field}} copié dans le presse-papiers !',
};
